import get from 'lodash/fp/get'
export const getFieldCount = get('fieldStats.fieldCount')
export const getFieldStats = get('fieldStats')
export const getFilteredFieldIds = get('fieldStats.fieldIds')
